import { render, staticRenderFns } from "./DropdownNavigation.vue?vue&type=template&id=bfe07b5c&"
import script from "./DropdownNavigation.vue?vue&type=script&lang=js&"
export * from "./DropdownNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports